import { combineReducers } from 'redux';

import authReducer from './auth/reducers';
import secureReducer from "./secure/reducers";
import appReducer from "./app/reducers";

export default combineReducers({
    auth: authReducer,
    secure: secureReducer,
    app: appReducer
});
